import { sendGTMEvent } from "../effects-bridge";
import { GA_CATEGORIES, GA_EVENTS } from "../data/gaConstants";

/**
 * `recommendations/analytics` — the flow's four GA events, in one file.
 *
 * They were previously emitted from four different layers (a saga, a widget, a screen container),
 * each rebuilding the same `{ category, ... }` envelope by hand. Collecting them here means a new
 * surface reports the same funnel as the POS without copying event names, and renaming an event
 * is one edit.
 *
 * `sendGTMEvent` comes from the EFFECTS BRIDGE, not from an app helper: each app wires its own
 * analytics implementation (react-ga4 on web, a native SDK on mobile) at boot.
 */

/** The engine answered (or failed to). `loadTimeMs` is rounded to 0.1 ms, as the apps do. */
export function trackRecommendationsFetched(params: {
  loadTimeMs: number;
  /** The response's id, the backend error code, or `"Failed"` when the request threw. */
  recommendationId?: string;
}) {
  sendGTMEvent({
    eventName: GA_EVENTS.RECOMMENDATIONS_FETCHED,
    params: {
      category: GA_CATEGORIES.SALE,
      loadTime: Math.round(params.loadTimeMs * 10) / 10,
      recommendationId: params.recommendationId,
    },
  });
}

/** Suggestions actually reached the screen. Fired ONCE per recommendationId, not per render. */
export function trackRecommendationsShown(recommendationId?: string) {
  sendGTMEvent({
    eventName: GA_EVENTS.RECOMMENDATIONS_SHOWN,
    params: {
      category: GA_CATEGORIES.SALE,
      recommendationId,
    },
  });
}

/** The operator opened or closed the widget by hand. */
export function trackRecommenderWidgetToggled(isOpening: boolean) {
  sendGTMEvent({
    eventName: isOpening ? GA_EVENTS.RECOMMENDER_WIDGET_OPENED : GA_EVENTS.RECOMMENDER_WIDGET_CLOSED,
    params: {
      category: GA_CATEGORIES.SALE,
    },
  });
}
